import React, { useState } from "react";
import axios from "axios";
import { useTheme } from "../config/ThemeContext";
import { Link, useNavigate } from "react-router-dom"; // Add useNavigate

const Login = ({ onLogin }) => {
  // Determine mode from environment variable or URL
  const isCloudMode = process.env.REACT_APP_AUTH_MODE === "supabase"   
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const colors = useTheme();
  const navigate = useNavigate(); // Add this

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    
    const requestBody = isCloudMode
      ? { email, password }
      : { username: email, password };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/auth/login`,
        requestBody,
        { withCredentials: true }
      );
      
      const { role } = response.data;
      
      onLogin({ role });
      
      // Use navigate instead of window.location
      navigate("/");
    } catch (err) {
      setErrorMsg(err.response?.data?.error || "Invalid credentials");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="bg-white p-8 rounded-xl shadow-lg w-full max-w-sm">
        <img
          src="/assets/logos/volleyfly-logo-300x111.png"
          alt="VolleyFly"
          className="mx-auto pb-4"
        />
        
        {/* Show mode badge */}
        <div className={`text-center mb-2 text-sm font-semibold ${
          isCloudMode ? "text-blue-600" : "text-green-600"
        }`}>
          {isCloudMode ? "🌐 Online" : "💻 Local Version"}
        </div>
        
        {errorMsg && (
          <p className="text-red-600 text-sm text-center mb-4">{errorMsg}</p>
        )}
        
        <center><i>"Ain't no volley high enough!"</i></center>
        
        <form onSubmit={handleSubmit} className="flex flex-col gap-4 mt-4">
          <input
            type={isCloudMode ? "email" : "text"}
            placeholder={isCloudMode ? "Email" : "Username"}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="border border-gray-300 rounded-lg px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="border border-gray-300 rounded-lg px-4 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button
            type="submit"
            className={`w-full ${colors.primary.bg} text-white font-semibold py-2 rounded-lg hover:brightness-110 transition-all`}
          >
            Login
          </button>
        </form>
        <div className="mt-6 pt-6 border-t border-gray-200">
          <p className="text-left text-gray-600 text-sm">
            Demo username: volleyflydemo@mailinator.com <br/>
			Demo password: demodemo
          </p>
        </div>
        
        {/* Add this section for signup link */}
        <div className="mt-6 pt-6 border-t border-gray-200">
          <p className="text-center text-gray-600 text-sm">
            Don't have an account?{" "}
            <Link 
              to="/signup" 
              className="text-blue-600 hover:text-blue-800 font-medium"
            >
              Sign Up
            </Link> 			 
          </p>
        </div>
		
		{/* Add forgot password link */}
<div className="mt-4 text-center">
  <Link 
    to="/request-password-reset" 
    className="text-blue-600 hover:text-blue-800 text-sm font-medium"
  >
    Forgot your password?
  </Link>
</div>
		
      </div>
    </div>
  );
};

export default Login;
